<template>
  <div>
    <div v-responsive.lg.xl class="pt-5">
             <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
             <section>
                <div class="mt-5 paralax-cover-image has-background-dim">
                    <div class="paralax-cover-image-text">
                    <div class="content_home" style="z-index: 1!important;">
                        <h1 style="text-align:left;font-size: 70px" class="font-weight-bold"><span style="color: #fff">{{ $t('assurances.assurances_sinistres.header_title[0]') }}</span></h1>
                        <h1 style="text-align:left;font-size: 70px;margin-top: -30px" class="font-weight-bold"><span style="color: #ffa409" class="ml-1">{{ $t('assurances.assurances_sinistres.header_title[1]') }}</span></h1>
                    </div>
                  </div>
                </div>
            </section>
        </div>
        <div v-responsive.sm.xs class="pt-5">
             <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
             <section>
                <div class="paralax-cover-image_mobile has-background-dim_mobile">
                    <p class="paralax-cover-image-text_mobile">
                        <div class="content_home" style="z-index: 1!important;margin-top: 10%">
                            <h1 style="font-size: 40px" class="font-weight-bold"><span style="color: #fff">{{ $t('assurances.assurances_sinistres.header_title[0]') }}</span></h1>
                            <h1 style="font-size: 40px;margin-top: -20px;color: #ffa409" class="font-weight-bold"><span>{{ $t('assurances.assurances_sinistres.header_title[1]') }}</span></h1>
                        </div>
                    </p>
                </div>
            </section>
        </div>
    <!-- <Banner title="Gestion Sinistres" image-path="assurance/sinistre.jpg"></Banner> -->
    <div class="row containers">
      <div class="col-md-7 col-sm-12" style="margin-top: 2%;">
        <div class="justify-content-center row">
          <div
            class="pa-2 text-justify subheading font-weight-blod pl-md-5 pr-md-5"
            style="margin-bottom: -50px"
          >
            {{ $t('assurances.assurances_sinistres.texte_intro[0]') }}<br>
            {{ $t('assurances.assurances_sinistres.texte_intro[1]') }}<br>
            {{ $t('assurances.assurances_sinistres.texte_intro[2]') }}<br>
            {{ $t('assurances.assurances_sinistres.texte_intro[3]') }}
            <div class="trigger_auto mt-3 mb-5">
              <span>
                <a href="/sinistre" style="text-decoration: none; color: #000000">
                    {{$t('assurances.assurances_sinistres.bouton_devis_gratuit')}}
                </a>
                <i style="font-size: 20px" class="ml-4 fas fa-chevron-right"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="divider mr-3 ml-3">
        <v-divider vertical></v-divider>
      </div>
      <div class="col-md-4 col-sm-12 mt-5">
        <DropdowAssurancePage>
          <template #label>
            {{ $t('assurances.assurances_sinistres.first_question_title') }}
          </template>
          {{ $t('assurances.assurances_sinistres.first_question_content[0]') }}<br>
          <span style="color: #ffa409">-</span> {{ $t('assurances.assurances_sinistres.first_question_content[1]') }}<br>
          <span style="color: #ffa409">-</span> {{ $t('assurances.assurances_sinistres.first_question_content[2]') }}
        </DropdowAssurancePage>
        <DropdowAssurancePage>
          <template #label>
            {{ $t('assurances.assurances_sinistres.second_question_title') }}
          </template>
          {{ $t('assurances.assurances_sinistres.second_question_content[0]') }}<br>
          {{ $t('assurances.assurances_sinistres.second_question_content[1]') }} <br>
          <span style="color: #ffa409">-</span> {{ $t('assurances.assurances_sinistres.second_question_content[2]') }} <br>
          <span style="color: #ffa409">-</span> {{ $t('assurances.assurances_sinistres.second_question_content[3]') }}
          <br>
          {{ $t('assurances.assurances_sinistres.second_question_content[4]') }}
        </DropdowAssurancePage>
        <DropdowAssurancePage>
          <template #label>
            {{ $t('assurances.assurances_sinistres.third_question_title') }}
          </template>
          {{ $t('assurances.assurances_sinistres.first_question_content[0]') }}<br>
          {{ $t('assurances.assurances_sinistres.third_question_content[0]') }} <br><br>
                  <span class="font-weight-bold">{{ $t('assurances.assurances_sinistres.third_question_content[1]') }}</span><br>
                  <span style="color: #ffa409">-</span> {{ $t('assurances.assurances_sinistres.third_question_content[2]') }} <br>
                  <span style="color: #ffa409">-</span> {{ $t('assurances.assurances_sinistres.third_question_content[3]') }} <span class="font-weight-bold" style="color:#ffa409">{{ $t('assurances.assurances_sinistres.third_question_content[4]') }}</span> <br>
                  <span style="color: #ffa409">-</span> {{ $t('assurances.assurances_sinistres.third_question_content[5]') }}
        </DropdowAssurancePage>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from '../layouts/banners/banner.vue';
import DropdowAssurancePage from './DropdowAssurancePage.vue';

export default {
  name: 'DescriptionAssuranceVieComponent',
  components: {
    Banner,
    DropdowAssurancePage
  }
};
</script>

<style scoped>
.containers {
  padding: 20px 8%;
  /* display: flex; */
}
.trigger_auto {
  width: 270px;
}
.trigger_auto span {
  font-weight: bold;
  font-size: 16px;
  background: #ffa409;
  color: #000000;
  height: 50px;
  padding: 0 18px;
  cursor: pointer;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
}
.grid-flex {
  margin-top: 10%;
}

@media only screen and (max-width: 767px) {
  .divider {
    display: none;
  }
}


.paralax-cover-image {
        background-image: url('../../assets/img/assurance/sinistre.jpg');
        position: relative;
        background-size: contain!important;
        background-position: 50%;
        min-height: 210px;
        width: 100%;
        margin: 0 0 0;
        display: flex;
        /*padding: 20px;*/
        align-items: center;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;

    }
    .paralax-cover-image p {
        color: rgb(255, 255, 255);
        font-size: 20px;
        font-weight: 300;
    }

    .paralax-cover-image .paralax-cover-image-text,
    .paralax-cover-image h2 {
        color: #fff;
        font-size: 2em;
        line-height: 1.25;
        z-index: 1;
        margin-bottom: 0;
        max-width: 610px;
        text-align: center;
        margin-left: 8.5%;
    }

    .paralax-cover-image.has-background-dim:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .paralax-cover-image {
        background-attachment: fixed;
        background-position: 50% 50px;
    }


  .paralax-cover-image_mobile {
        background-image: url('../../assets/img/assurance/sinistre_mobile.jpg');
        position: relative;
        background-size: contain;
        background-position: 50%;
        min-height: 150px;
        width: 100%;
        margin: 0 0 0;
        display: flex;
       /*padding: 20px;*/
        align-items: center;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;

    }
    .paralax-cover-image_mobile p {
        color: rgb(255, 255, 255);
        font-size: 20px;
        font-weight: 300;
        padding-bottom: 20Px;
    }

    .paralax-cover-image_mobile .paralax-cover-image-text_mobile,
    .paralax-cover-image_mobile h2 {
        color: #fff;
        font-size: 2em;
        line-height: 1.25;
        z-index: 1;
        margin-bottom: 0;
        max-width: 610px;
        text-align: center;
        margin-left: 8.5%;
    }

    .paralax-cover-image_mobile.has-background-dim_mobile:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .paralax-cover-image_mobile {
        /* background-attachment: fixed; */
        background-position: 100% 40px;
    }
</style>
